<div class="banner" [class.rtl]="localeService.lang === 'ku' || localeService.lang === 'ar'">
	<h6>{{ localeService.translations['ads']['n446'] }}</h6>
	<button class="btn btn-sm bg-white" [routerLink]="['/placead']">
		{{ localeService.translations['dealer']['n364'] }}
	</button>
</div>
